import { AdditionalField, Widgets } from 'features/settings/mobile-editor/interfaces';
import { MetaHubstrFieldsGroup } from 'features/residents/layouts/meta-hubstr';
import { TranslatesList as t } from 'features/settings/editor/residents-editor/requests';
import { ADMIN_GROUP_TYPES } from 'features/settings/mobile-editor/constants';
import AdminFieldEntity from 'features/settings/mobile-editor/factories/admin-field-entity';
import { IViewWidgets } from 'features/settings/editor/residents-editor/interfaces';
import { APP_CILICIA, SUB_DOMEN } from '~/constants';

/**
 * @param mobileView
 * */
const parseForAdmin = (mobileView: IViewWidgets) => {
  const body: MetaHubstrFieldsGroup[] = [];

  // Группы
  mobileView.body
    .filter((group) => ![ADMIN_GROUP_TYPES.SOCIAL, ADMIN_GROUP_TYPES.CONTACTS, ADMIN_GROUP_TYPES.COMMUNITIES].includes(group.adminGroupType))
    .forEach((group) => {
      const fieldsGroup: MetaHubstrFieldsGroup = {
        title: t[group.title.replace('lang.', '')] || group.title,
        fields: [],
      };

      // Виджеты
      group.widgets
        .filter((widget) => widget.text !== 'data.additions.userBadge' && widget.text !== 'data.additions.userCity')
        .forEach((widget) => {
          if ('additions' in widget) {
            // Генерируем поле
            const fieldFactoryInit = new AdminFieldEntity(widget, widget.additions, t);
            fieldsGroup.fields.push(fieldFactoryInit.create() as never);
          }
        });

      // Фильтруем пустые группы
      if (fieldsGroup.fields.length) {
        body.push(fieldsGroup);
      }
    });

  const statusIcon = mobileView.header.find((w) => w.type === 'header_title_with_icon_widget');
  if (statusIcon && SUB_DOMEN === APP_CILICIA) {
    body.unshift({
      title: '',
      fields: [{
        type: 'radio',
        name: 'userTitleIcon',
        label: statusIcon.label || 'Статус',
        options: [
          {
            label: 'Да',
            value: 'crown',
          },
          {
            label: 'Нет',
            value: 'crown_outlined',
          },
        ],
      }],
    } as any);
  }

  return body;
};

export default parseForAdmin;
